module.exports = __webpack_public_path__ + "static/media/a_rest_thumb_even.577bcc38.jpg";